import React from 'react';

import Pane from 'ui-library/pane/Pane';

import {SharedUniversalBlockViewProps} from './SharedUniversalBlockViewTypes';

/**
 * Presentational component of a Universal Block that is empty.
 *
 * Useful if the caller wants to render a block but doesn't have a config or data to render it with. This could be
 * useful while those are still loading for example, and in that case we could wrap this block with a
 * `LoadingOverlay` to show that the block is loading.
 */
export default function BlankUniversalBlockView({paneProps}: SharedUniversalBlockViewProps): JSX.Element {
  return (
    <Pane {...paneProps} centerContent={true}>
      <div />
    </Pane>
  );
}
